var map = {
	"./2.jpg": 26659,
	"./4.jpg": 2605,
	"./5.jpg": 34032,
	"./6.jpg": 48383,
	"./7.jpg": 56674,
	"./ALL ANIMALS.jpg": 77415,
	"./BIRD.jpg": 58800,
	"./BOY 1.jpg": 32642,
	"./BOY 9.jpg": 59818,
	"./RABBIT 4 NEW.jpg": 1579,
	"./angry bird.jpg": 11277,
	"./apple &banana.jpg": 80888,
	"./apple.jpg": 66417,
	"./bird 10.jpg": 80441,
	"./bird 3.jpg": 57991,
	"./bird 4.jpg": 56444,
	"./bird 7.jpg": 24747,
	"./bird 8.jpg": 16816,
	"./birds with girl.jpg": 54923,
	"./boy 01.jpg": 37010,
	"./boy 02.jpg": 55965,
	"./boy 7.jpg": 67700,
	"./boy.jpg": 82031,
	"./butter fly & rabbit.jpg": 13084,
	"./butter flys.jpg": 22317,
	"./cycle.jpg": 76071,
	"./dol.jpg": 97348,
	"./dolphin 1.jpg": 93448,
	"./duck 1.jpg": 8987,
	"./elephant 4.jpg": 33610,
	"./elephant 6.jpg": 96568,
	"./fish 1.jpg": 49122,
	"./fish 2-Recovered.jpg": 77781,
	"./fox.jpg": 11542,
	"./girl 1.jpg": 80698,
	"./girl 5.jpg": 78686,
	"./girl birds.jpg": 96191,
	"./girl.jpg": 65351,
	"./honey bee 01.jpg": 17403,
	"./honey bee.jpg": 85092,
	"./ice-cream.jpg": 98469,
	"./lion 1.jpg": 57570,
	"./lion 2.jpg": 89709,
	"./mango 1-Recovered.jpg": 73086,
	"./pecock 1.jpg": 67817,
	"./psd mdl 6.jpg": 46315,
	"./rat 2.jpg": 68746,
	"./rat.jpg": 144,
	"./smal tiger.jpg": 52011,
	"./tiger 01.jpg": 78559,
	"./tiger.jpg": 34608,
	"./vegetables 1.jpg": 97672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17603;